import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import Check from '@mui/icons-material/CheckCircleOutline';
import Circle from '@mui/icons-material/RadioButtonUnchecked';
import { isDefined } from 'lib/typeInference';
import { useCurrencyString } from 'lib/useCurrencyString';
import { IAdjustmentLocalResource } from 'components/order/model/Order';
import { IAdjustmentReadResourceV22 } from 'components/basket/model/Basket';

const PREFIX = 'PayAwardItem';

const classes = {
    text: `${PREFIX}text`
};

const StyledBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
    [`& .${classes.text}`]: {
        fontSize: '14px',
        fontWeight: 400
    }
}));

interface PayAwardItemProps {
    item: IAdjustmentLocalResource | IAdjustmentReadResourceV22;
    onClick: (awardId: string) => void;
    selected?: boolean;
}

export const PayAwardItem: React.FC<React.PropsWithChildren<PayAwardItemProps>> = ({
    item,
    onClick,
    selected
}) => {
    const getCurrencyString = useCurrencyString();
    const handleClick = React.useCallback(() => {
        if (isDefined(item.awardId)) {
            onClick(item.awardId);
        }
    }, [item, onClick]);
    const value = React.useMemo(() => {
        if ('totalValue' in item) {
            return item.totalValue ? ` (${getCurrencyString(item.totalValue)})` : '';
        }
        return ` (${getCurrencyString(item.value * (item.quantity ?? 1))})`;
    }, [getCurrencyString, item]);
    return (
        <StyledBox onClick={handleClick}>
            <Typography className={classes.text}>
                {item.description}
                {value}
            </Typography>
            {selected ? <Check color="inherit" /> : <Circle color="inherit" />}
        </StyledBox>
    );
};
